import {
  Component,
  ComponentRef,
  OnInit,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import {
  GlobalConstantsSonstige,
  GlobalFunctionsGui,
  GlobalService,
  InputErrorStateMatcher,
} from 'globales-projekt-angular';
import { Guid } from 'guid-typescript';
import { Gebaeude } from 'src/app/data/ws/dbKlassen/gebaeude.model';
import { ApiService } from 'src/app/services/api.service';
import { UebersichtTabelleComponent } from 'src/app/components/blocks/uebersicht-tabelle/uebersicht-tabelle.component';
import { FilterAuspRowComponent } from 'src/app/components/blocks/filter/filter-ausp-row/filter-ausp-row.component';
import { FilterWertRowComponent } from 'src/app/components/blocks/filter/filter-wert-row/filter-wert-row.component';
import { LocalService } from 'src/app/services/local.service';
import { SpinnerService } from 'src/app/components/elemente/mat-spinner-overlay/service/spinner.service'
import { ConstantsSonstige } from 'src/app/immutable/constants-sonstige';
import { filter, take } from 'rxjs';
import { ConstantsTexte } from 'src/app/immutable/constants-texte';
import { ConstantsTabMain } from 'src/app/immutable/tabs/constants-tab-main';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css'],
})
export class MainComponent implements OnInit {
  position = new FormControl(GlobalConstantsSonstige.POSITION_OPTIONS[1]);

  matcher: InputErrorStateMatcher = new InputErrorStateMatcher();

  gebklasseFormControl: FormControl = new FormControl(null);
  tierkategorieFormControl: FormControl = new FormControl(null);
  tierkategorieText!: string;

  childGuidUebersichtTable: Guid[] = [];

  childRefUebersichtTableMap: Map<boolean, ComponentRef<UebersichtTabelleComponent>> = new Map<boolean, ComponentRef<UebersichtTabelleComponent>>();

  childGuidFilterWertRow: Guid[] = [];
  childRefFilterWertRow: ComponentRef<FilterWertRowComponent>[] = [];

  childGuidFilterAuspRow: Guid[] = [];
  childRefFilterAuspRow: ComponentRef<FilterAuspRowComponent>[] = [];

  isSelectedGebaeudeExpandet: boolean = true;

  selectedTabIndex: number = 0;
  selectedTabIndexOld: number = 0;



  constructor(
    private apiService: ApiService,
    private globalService: GlobalService,
    public localService: LocalService,
    public spinnerService: SpinnerService,
    private route: ActivatedRoute
  ) {
  }

  ngOnInit(): void {

    this.localService.mainComponentRef.next(this);

    this.route.queryParams.subscribe(params => {
      this.startUpParameter(params[ConstantsSonstige.STARTUP_PARAMETER]);
    });

    if (!this.localService.fromErgebnis.value) {
      this.getGebklassen();
      this.getTierkategorien();
      this.getPreisstaende();
    }
  }

  startUpParameter(idGebaeude: number) {
    if (idGebaeude) {
      this.getIstGebaeude(idGebaeude)

      this.globalService.database.subscribe(() => {
      });

      let gebaeude: Gebaeude = new Gebaeude();
      gebaeude.idGebaeude = idGebaeude;
      this.localService.selectedGebaeudeList.value.push(gebaeude);

      this.localService.preisstandList
        .pipe(
          filter(value => value != null && value.length > 0),
          take(1)
        )
        .subscribe(() => {
          this.selectedTabIndex = 1;
        });
      
    }
    else {
      this.globalService.database.subscribe(() => {
      });
    }
  }

getIstGebaeude(idGebaeude: number) {
  this.waitingForDataSpinner(true);

  this.apiService.getIstGebaeude(idGebaeude).subscribe({
    next: (response) => {
      if (response == null) {
        alert(ConstantsTexte.FEHLER_KEINE_GEBAEUDE_GEFUNDEN);
        return;
      }
      this.localService.istGebaeude.next(response === 1);
      this.waitingForDataSpinner(false);
    },
    error: () => {
    }
  });
}


  getPreisstaende() {

    this.waitingForDataSpinner(true);
    this.apiService.getPreisstaende().subscribe((response) => {
      this.localService.preisstandList.next(response);
      this.localService.selectedPreisstand.next(response[0]);

      this.waitingForDataSpinner(false);
    });
  }

  getGebklassen() {
    this.waitingForDataSpinner(true);

    this.apiService.getGebklassen().subscribe((response) => {
      this.localService.gebklasseList.next(response);

      this.waitingForDataSpinner(false);
    });
  }

  getTierkategorien() {
    this.waitingForDataSpinner(true);

    this.apiService.getTierkategorien().subscribe((response) => {
      this.localService.tierkategorieList.next(response);

      this.waitingForDataSpinner(false);
    });
  }

  beforeTabChange() {
    if (this.localService.einstellungenComponentRef.value?.isDataChanged) {


      if (!confirm(ConstantsTexte.EINSTELLUNG_TEXT_WECHSEL)) {

        setTimeout(() => {


          this.selectedTabIndex = 2; // Wechsel verhindern
        }, 0);
      }
      else {
        this.localService.einstellungenComponentRef.value.onClickUndo();


      }
      /*
      setTimeout(() => { 
        
              this.selectedTabIndex = this.selectedTabIndexOld;
            }, 0); 
            this.selectedTabIndexOld = this.selectedTabIndex;
            */
    }
  }

  onClickZuErgebnisse() {

    this.selectedTabIndex = ConstantsTabMain.TAG_ERGEBNISSE;
  }

  onClickZurAuswahl() {
    this.selectedTabIndex = ConstantsTabMain.TAB_AUSWAHL;
  }

 
  public waitingForDataSpinner(wait: boolean) {
    if (wait) this.spinnerService.show();
    else this.spinnerService.hide();

    this.globalService.isShowSpinner.next(this.spinnerService.getCountSpinner() != 0);
  }

  onClickUp() {
    GlobalFunctionsGui.clickUp();
  }

  onClickDown() {
    GlobalFunctionsGui.clickDown();
  }
}
